import React, { useState } from "react";
import Button from "./Button";
import Icon from "../../../assets/icons/Icon";
import Error from "./Error";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { hashedPassword } from "../../helper/common";
import {
  API_GET_MARKET_OPERATION,
  API_POST_MARKET_OPERATION_RUNNERS,
} from "../../../utils/api/ApiConstant";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getAxios, postAxios } from "../../Services/commonService";
import { CommonModal } from "../Modal";

const confirmationSchema = Yup.object({
  password: Yup.string().trim().required("Password is required"),
});

const Password = ({ onConfirm, onCancel, disabled = false }) => {
  const [showHide, setShowHide] = useState(false);
  const { isLoading } = useSelector((state) => state.ui);

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
    },
    resolver: yupResolver(confirmationSchema),
    mode: "onTouched",
  });

  const onSubmit = ({ password, result }) => {
    const storedHash = localStorage.getItem("cipherMark");
    const finalHash = hashedPassword(password);

    console.log("storedHash", storedHash);
    console.log("finalHash", finalHash);

    if (!storedHash || storedHash !== finalHash) {
      setError("password", {
        type: "manual",
        message: "Incorrect password",
      });
      return;
    }
    clearErrors("password");
    onConfirm?.();
    onCancel?.();
  };

  const renderPasswordField = () => (
    <div className="form-group">
      <label className="form-label" htmlFor="password">
        Password
      </label>
      <div className="password-field">
        <input
          type={showHide ? "text" : "password"}
          className="form-control"
          id="password"
          placeholder="Enter password"
          {...register("password")}
        />
        <button
          type="button"
          className="password-toggle"
          onClick={() => setShowHide((prev) => !prev)}
          aria-label={showHide ? "Hide password" : "Show password"}
        >
          {showHide ? <Icon name="EyeClosed" /> : <Icon name="Eye" />}
        </button>
      </div>
      {errors.password && <Error>{errors.password.message}</Error>}
    </div>
  );

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="section_main">
          {renderPasswordField()}

          <div className="actions-grape split">
            <Button
              type="button"
              className="btn btn_main btn_muted w-100 justify-content-center"
              onClick={onCancel}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              className="btn btn_main w-100 justify-content-center"
              disabled={
                isLoading ||
                (typeof disabled === "function" ? disabled() : disabled)
              }
            >
              Submit
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};

export default Password;
